// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"166":"bd513ff7","625":"28706101","756":"73ee9bd3","780":"9f8134e7"}[chunkId] + ".css";
};